
export type ResourceType = 'Audio' | 'PDF' | 'E-book' | 'Taller' ;

export interface Resource {
  id: string;
  title: string;
  description: string;
  type: ResourceType[];
  price?: string; // e.g. "Gratis" or "$1500"
  previousPrice?: string; // e.g. "$500" - Optional anterior price for offers
  priceDolars?: string; // e.g. "Gratis" or "$1500"
  previousPriceDolars?: string; 
  imageUrl?: string;
  link: string; // URL to download or buy
  buttonText: string;
  isNew?: boolean;
  isKit?: boolean;
} 

export const resources: Resource[] = [
  {
    id: '1',
    title: 'Manual de consultas en emergencia',
    description: 'Una guía clara para saber cuándo consultar en emergencia, qué observar en tu cuerpo y en tu bebé, y cómo tomar decisiones con más calma en momentos de urgencia.',
    type: ['PDF'],
    price: 'Gratis',
    link: '/resources/Manual-de-consulta-en-emergencia.pdf',
    buttonText: 'Descargar',
    imageUrl: '/images/resources/1.avif',
    isNew: true
  },
  {
    id: '2',
    title: 'Tu cuerpo sabio',
    description: 'Un recurso para conectar con tu cuerpo durante el embarazo, comprender sus señales y fortalecer la confianza en tu capacidad de gestar y parir.',
    type: ['PDF'],
    price: '$350',
    priceDolars: 'US$ 9',
    link: 'https://drive.google.com/file/d/1-gs0ugcZueaiKrbaI-TS9yg5dSkoRzLu/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/2.avif'
  },
  {
    id: '3',
    title: 'Nacimiento, tu guía para el gran día',
    description: 'Información esencial para comprender el proceso del nacimiento, qué esperar y cómo prepararte física y emocionalmente para vivirlo con mayor seguridad y presencia.',
    type: ['PDF'],
    price: '$500',
    priceDolars: 'US$ 13',
    link: 'https://drive.google.com/file/d/13QucCJi4ttgBowkYdCFtAuOO2NAMF7AW/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/3.avif'
  },
  {
    id: '4',
    title: 'Check list vuelta a casa con tu bebé',
    description: 'Una lista simple y amorosa para acompañarte a organizar desde tu embarazo la vuelta a casa.',
    type: ['PDF'],
    price: '$200',
    priceDolars: 'US$ 5',
    link: 'https://drive.google.com/file/d/1wgK4PCZiU_rJZr9uFeCeqQPcLE3jnfuu/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/4.avif'
  },
  {
    id: '5',
    title: 'Comunicación y acuerdos en la pareja',
    description: 'Una guía para abrir conversaciones importantes antes del nacimiento: roles, expectativas, límites y necesidades, fortaleciendo el equipo que va a cuidar.',
    type: ['PDF'],
    price: '$350',
    priceDolars: 'US$ 9',
    link: 'https://drive.google.com/file/d/1HCUAadswBb0JjdvF1loXsgH8GtYC65Yp/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/5.avif'
  },
  {
    id: '6',
    title: 'Tus derechos Uruguay',
    description: 'Información clara sobre tus derechos durante el embarazo, el parto y el puerperio, para que puedas decidir informada y sostener tu voz en el sistema de salud.',
    type: ['PDF'],
    price: 'Gratis',
    link: '/resources/Derechos-en-el-embarazo-y-parto-Uruguay.pdf',
    buttonText: 'Descargar',
    imageUrl: '/images/resources/6.avif',
    isNew: true
  },
  {
    id: '7',
    title: 'Tus derechos Argentina',
    description: 'Información clara sobre tus derechos durante el embarazo, el parto y el puerperio, para que puedas decidir informada y sostener tu voz en el sistema de salud.',
    type: ['PDF'],
    price: 'Gratis',
    link: '/resources/Derechos-en-el-embarazo-y-parto-Argentina.pdf',
    buttonText: 'Descargar',
    imageUrl: '/images/resources/7.avif'
  },
  {
    id: '8',
    title: 'Miedos en el embarazo',
    description: 'Un recurso para identificar y comprender los miedos más frecuentes del embarazo, transformándolos en información y autoconfianza.',
    type: ['PDF'],
    price: '$350',
    priceDolars: 'US$ 9',
    link: 'https://drive.google.com/file/d/1kErgWS0kxZHNqo16srOSck9KuHdrJ0a-/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/8.avif'
  },
  {
    id: '9',
    title: 'Puerperio',
    description: 'Una guía completa y amorosa para comprender el posparto real: cambios físicos, emocionales y vinculares, y cómo cuidarte mientras cuidás.',
    type: ['PDF'],
    price: '$500',
    priceDolars: 'US$ 13',
    link: 'https://drive.google.com/file/d/118kkhKThcVdeO4lOVaXFoiuVKWcCx5qY/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/9.avif'
  },
  {
    id: '10',
    title: 'Vínculo con tu bebé desde la panza',
    description: 'Propuestas simples para fortalecer el vínculo con tu bebé durante el embarazo y acompañar la conexión emocional desde el inicio.',
    type: ['PDF'],
    price: '$400',
    priceDolars: 'US$ 10',
    link: 'https://drive.google.com/file/d/1NJsClBXnavqTseRs8ZM3F0VHdwZqRHoL/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/10.avif'
  },
  {
    id: '11',
    title: 'Kit de acompañamiento en el inicio del trabajo de parto ¿Es ahora?',
    description: 'Un kit pensado para el umbral del parto: reconocer señales, escuchar tu cuerpo y transitar el inicio con calma y contención. PDF ¿Es ahora? Guía principal, PDF Escuchar al cuerpo, PDF registro de contracciones,Audios de acompañamiento',
    type: ['PDF', 'Audio'],
    price: '$580',
    priceDolars: 'US$ 15',
    link: 'https://drive.google.com/file/d/1kErgWS0kxZHNqo16srOSck9KuHdrJ0a-/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/11.avif',
    isKit: true
  },
  {
    id: '12',
    title: 'Kit embarazo consciente',
    description: 'PDF Tu cuerpo sabio. PDF Vínculo con tu bebé. Taller grabado de miedos',
    type: ['PDF', 'Taller'],
    price: '$1240',
    priceDolars: 'US$ 31',
    previousPrice: '$1650',
    previousPriceDolars: 'US$ 41',
    link: 'https://drive.google.com/file/d/1b62PKF4a2ERljhYz0H1wfzo1S6j_LQD-/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/12.avif',
    isKit: true
  },
  {
    id: '13',
    title: 'Kit Camino al nacimiento',
    description: 'PDF Nacimiento, tu guía para el gran día. PDF ¿Es ahora?. PDF Comunicación con la pareja',
    type: ['PDF'],
    price: '$870',
    priceDolars: 'US$ 22',
    previousPrice: '$1150',
    previousPriceDolars: 'US$ 29',
    link: 'https://drive.google.com/file/d/1wRLYHBKlOEnBcg0pMwUyNs0dq7Pipadq/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/13.avif',
    isKit: true
  },
  {
    id: '14',
    title: 'Kit Primeros días sostenidos',
    description: 'PDF Puerperio. PDF Vuelta a casa. Taller grabado primeros 30 días con el bebé.',
    type: ['PDF', 'Taller'],
    price: '$900',
    priceDolars: 'US$ 23',
    previousPrice: '$1200',
    previousPriceDolars: 'US$ 30',
    link: 'https://drive.google.com/file/d/1eec2bXvqH-q0K1_QTBvZVTZ3ey24Tm0x/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/14.avif',
    isKit: true
  },
  {
    id: '15',
    title: 'Taller de miedos',
    description: 'Un taller grabado para trabajar los miedos vinculados al embarazo y al parto, combinando información, reflexión y herramientas emocionales.',
    type: ['Taller'],
    price: '$900',
    priceDolars: 'US$ 23',
    link: 'https://drive.google.com/file/d/1jbMXrtVEwZaJuf4v9HKA57dqP6kPFj2A/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/15.avif'
  },
  {
    id: '16',
    title: 'Masterclass compras inteligentes',
    description: 'Una guía práctica para decidir qué comprar (y qué no) para tu bebé, evitando gastos innecesarios.',
    type: ['Taller'],
    price: '$500',
    priceDolars: 'US$ 13',
    link: 'https://drive.google.com/file/d/1DHbfjB92jD_39XnEuOWGif8_YQJa4s7B/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/16.avif'
  },
  {
    id: '17',
    title: 'Masterclass primeros 30 días con el bebé',
    description: 'Información clave para transitar el primer mes: necesidades reales del bebé, organización del cuidado y sostén emocional para la familia.',
    type: ['Taller'],
    price: '$500',
    priceDolars: 'US$ 13',
    previousPrice: '$1200',
    previousPriceDolars: 'US$ 30',
    link: 'https://drive.google.com/file/d/1f1jVBcMXaI6EctuT_6IbMYurn9CZhOtk/view?usp=drive_link',
    buttonText: 'Comprar',
    imageUrl: '/images/resources/17.avif'
  }
];
